import React, { useEffect, useState } from 'react'
import Spinner from 'transfix-ui/components/Spinner'
import { Table, TableBody, TableCell, TableHead, TableRow } from 'transfix-ui/components/Table'
import { Box, makeStyles } from 'transfix-ui/core'
import { brandColors, theme } from 'transfix-ui/theme'
import { LastCreatedShipmentsForm } from '../forms/LastCreatedShipmentsForm/LastCreatedShipmentsForm'
import { TLastCreatedShipmentsFormSchema } from '../forms/LastCreatedShipmentsForm/LastCreatedShipmentsFormSchema'
import { useStagingTestingLastCreatedShipmentsLazyQuery } from '../graphql/StagingTestingLastCreatedShipments'

interface ILastCreatedShipmentsProps {
  /**
   * @example '25'
   */
  inboundConnectionConfigId: string
}

const useLastCreatedShipmentsStyles = makeStyles({
  table: {
    background: 'transparent',
    marginTop: theme.spacing(1),
    '& thead': {
      background: 'transparent',
    },
    '& th:first-child, td:first-child': {
      paddingLeft: 0,
    },
    '& td': {
      borderBottom: `1px solid ${brandColors.coolGray3}`,
    },
  },
})

export const LastCreatedShipments = ({ inboundConnectionConfigId }: ILastCreatedShipmentsProps) => {
  const classes = useLastCreatedShipmentsStyles()
  const [lastCreatedShipments, setLastCreatedShipments] = useState<String[]>()

  const [
    getLastCreatedShipments,
    { data, loading },
  ] = useStagingTestingLastCreatedShipmentsLazyQuery()

  const submitHandler = (formData: TLastCreatedShipmentsFormSchema) => {
    getLastCreatedShipments({
      variables: {
        inboundConnectionConfigId,
        top: formData.numberOfShipments,
      },
    })
  }

  const defaultValues = {
    numberOfShipments: 5,
  }

  /*
   Set the last created shipments list we receive from GraphQL query result
   */
  useEffect(() => {
    setLastCreatedShipments(data?.stagingTestingLastCreatedShipments || [])
  }, [data?.stagingTestingLastCreatedShipments, getLastCreatedShipments])

  return (
    <Box mt={2}>
      <LastCreatedShipmentsForm onSubmit={submitHandler} defaultValues={defaultValues} />
      <hr />
      {loading && <Spinner position='relative' />}
      <Table className={classes.table}>
        <TableHead>
          <TableRow tableCellType='th'>
            <TableCell>Shipment ID</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {lastCreatedShipments && lastCreatedShipments.length > 0 ? (
            lastCreatedShipments.map((shipment, index) => (
              <TableRow key={String(index)}>
                <TableCell>
                  <a
                    href={`${__ROOT__}/shipment-details/${shipment}?tab=scheduling`}
                    target='_blank'
                    rel='noopener noreferrer'>
                    {shipment}
                  </a>
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell className='tc'>No shipments found</TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </Box>
  )
}
